<template>
  <div class="slide">
    <div class="dragContainer" ref='dragContainer'>
      <div class="dragBg" ref='dragBg'></div>
      <div class="dragText isok" v-if='isVertifySucc'>验证通过</div>
      <div class="dragText" v-else>拖动滑块验证</div>
      <div class="dragHandler dragHandlerBg" ref='dragHandler' :class='{dragHandlerOkBg: isVertifySucc}'></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  data () {
    return {
      maxHandlerOffset: '',
      beginX: ''
    }
  },
  computed: {
    ...mapGetters([
      'isVertifySucc'
    ]),
    isOk () {
      return this.isVertifySucc
    }
  },
  mounted () {
    this.initDrag()
  },
  methods: {
    // 验证码色条移动设置
    Left () {
      if (!this.isOk) {
        this.$refs.dragHandler.style.left = 0
        this.$refs.dragBg.style.width = this.$refs.dragHandler.style.left
      }
    },
    initDrag () {
      this.$refs.dragHandler.addEventListener('mousedown', this.onDragHandlerMouseDown)
      this.$refs.dragHandler.addEventListener('touchstart', this.onDragHandlerMouseDown)
    },
    onDragHandlerMouseDown (event) {
      this.beginX = event.clientX || event.changedTouches[0].clientX
      this.maxHandlerOffset = this.$refs.dragContainer.clientWidth - this.$refs.dragHandler.clientWidth
      document.addEventListener('mousemove', this.onDragHandlerMouseMove)
      document.addEventListener('mouseup', this.onDragHandlerMouseUp)
      document.addEventListener('touchmove', this.onDragHandlerMouseMove)
      document.addEventListener('touchend', this.onDragHandlerMouseUp)
    },
    onDragHandlerMouseMove (event) {
      var left = (event.clientX || event.changedTouches[0].clientX) - this.beginX - this.$refs.dragHandler.clientWidth
      if (left < 0) {
        left = 0
      } else if (left > this.maxHandlerOffset) {
        left = this.maxHandlerOffset
        this.verifySucc()
      }
      this.$refs.dragHandler.style.left = left + 'px'
      this.$refs.dragBg.style.width = this.$refs.dragHandler.style.left
    },
    onDragHandlerMouseUp () {
      document.removeEventListener('mousemove', this.onDragHandlerMouseMove)
      document.removeEventListener('mouseup', this.onDragHandlerMouseUp)
      document.removeEventListener('touchmove', this.onDragHandlerMouseMove)
      document.removeEventListener('touchend', this.onDragHandlerMouseUp)
      this.$refs.dragHandler.style.left = 0
      this.$refs.dragBg.style.width = 0
    },
    verifySucc () {
      this.$store.dispatch('change_isvertifysucc', true)
      this.$refs.dragHandler.removeEventListener('mousedown', this.onDragHandlerMouseDown)
      document.removeEventListener('mousemove', this.onDragHandlerMouseMove)
      document.removeEventListener('mouseup', this.onDragHandlerMouseUp)
      this.$refs.dragHandler.removeEventListener('touchstart', this.onDragHandlerMouseDown)
      document.removeEventListener('touchmove', this.onDragHandlerMouseMove)
      document.removeEventListener('touchend', this.onDragHandlerMouseUp)
    }
  },
  watch: {
    isOk () {
      this.Left()
    }
  }
}
</script>

<style lang="less" scoped>
.dragContainer {
    position: relative;
    display: inline-block;
    background: #e8e8e8;
    width: 350px;
    height: 44px;
    border: 2px solid #e8e8e8;
    margin-bottom: 0;
}
.dragBg {
    position: absolute;
    background-color: #76c61d;
    width: 0;
    height: 100%;
}
.dragText {
    position: absolute;
    width: 100%;
    height: 100%;
    color: #666;
    text-align: center;
    line-height: 44px;
    user-select: none;
    -webkit-user-select: none;
    &.isok {
      color: #fff;
    }
}
.dragHandler {
    position: absolute;
    width: 50px;
    height: 100%;
    cursor: move;
}
.dragHandler {
    background: #fff url('../../../static/img/forget_pwd/to_right.png') no-repeat center;
}
.dragHandlerOkBg {
    background: #fff url('../../../static/img/forget_pwd/is_ok.png') no-repeat center;
}
@media screen and (max-width: 767px) {
  .dragContainer{
    width: 98%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/SlidingValidate.vue